import { render, staticRenderFns } from "./SwitchTab.vue?vue&type=template&id=285154df"
import script from "./SwitchTab.vue?vue&type=script&lang=js"
export * from "./SwitchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports